import React from 'react';
import { ClipboardList, MessageCircleQuestion, CalendarClock, Phone, Mail } from 'lucide-react';
import Seo from '../components/Seo';
import { CLINIC, IMAGES } from '../mock';

const options = [
  {
    icon: ClipboardList,
    title: 'Request a Consultation',
    desc: 'Not sure where to start? Reach out for a free initial consultation to discuss your needs, goals, and how I can help.',
    emailSubject: 'Free Consultation Request',
  },
  {
    icon: MessageCircleQuestion,
    title: 'Ask a Question',
    desc: 'Have a question about therapy, insurance, availability, or approaches? Get in touch and I will personally respond.',
    emailSubject: 'Question for The Mood & Sleep Clinic',
  },
  {
    icon: CalendarClock,
    title: 'Schedule an Appointment',
    desc: 'Ready to begin? Contact me directly and we will find a session time that fits your schedule.',
    emailSubject: 'Appointment Request',
  },
];

const GettingStarted = () => {
  return (
    <div>
      <Seo
        title="Getting Started — Begin Your Recovery"
        description="Ready to begin? Connect with The Mood & Sleep Clinic to request a consultation, ask a question, or schedule an appointment. Call (507) 403-7976 or email us."
        path="/getting-started"
      />
      <div className="h-24 sm:h-32 w-full bg-cover bg-center" style={{ backgroundImage: `url(${IMAGES.waterBanner})` }} />
      <section className="bg-sky-band">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
          <h1 className="font-heading font-light text-navy text-3xl sm:text-4xl md:text-5xl tracking-wide fade-up">Begin Your Recovery Here</h1>
          <p className="mt-3 text-navy/70 text-lg">Choose how you&rsquo;d like to connect &mdash; just call or email.</p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            {options.map((o) => (
              <div
                key={o.title}
                className="text-center flex flex-col items-center bg-white rounded-2xl border border-border p-8 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-16 h-16 rounded-full bg-secondary flex items-center justify-center text-navy">
                  <o.icon size={28} strokeWidth={1.6} />
                </div>
                <h2 className="mt-5 font-heading text-xl text-navy">{o.title}</h2>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed flex-1">{o.desc}</p>

                <div className="mt-6 w-full space-y-3">
                  <a
                    href={CLINIC.phoneHref}
                    className="flex items-center justify-center gap-2 rounded-full bg-navy text-white px-5 py-2.5 text-sm font-heading font-medium hover:bg-[#2c4d76] transition-colors"
                  >
                    <Phone size={16} /> Call
                  </a>
                  <a
                    href={`${CLINIC.emailHref}?subject=${encodeURIComponent(o.emailSubject)}`}
                    className="flex items-center justify-center gap-2 rounded-full border border-navy/30 text-navy px-5 py-2.5 text-sm font-heading font-medium hover:bg-secondary transition-colors"
                  >
                    <Mail size={16} /> Email
                  </a>
                </div>
              </div>
            ))}
          </div>

          <p className="mt-12 text-xs text-muted-foreground leading-relaxed max-w-3xl mx-auto text-center">
            <strong className="text-navy/80">Privacy Policy:</strong> The Mood and Sleep Clinic does not share your personal data with any organization aside from health insurance companies involved in your medical care. Your data is kept private and will never be used for promotional, sales, or other non-treatment related purposes. By contacting the clinic by telephone or email, you are consenting to be contacted in return regarding your inquiry.
          </p>
        </div>
      </section>
    </div>
  );
};

export default GettingStarted;
